import { render, staticRenderFns } from "./OneSidebar.vue?vue&type=template&id=9c1faec2&scoped=true&"
import script from "./OneSidebar.vue?vue&type=script&lang=ts&"
export * from "./OneSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./OneSidebar.vue?vue&type=style&index=0&id=9c1faec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1faec2",
  null
  
)

export default component.exports